export const datagridPageSizeOptions= [20,50,100];
export const shDatagridPageSizeOptions= [20,50,100,200];

// Row height options for ShDataGrid3. Fixed px values for predictable virtualization,
// plus the sentinel "auto" which switches the grid to content-fit mode with a minimum
// 8px top/bottom padding (see ShGridBody's .sh-grid-row--auto-height selector).
// `i18nKey` is passed through the UI's translate call so labels can localize.
export const shDatagridRowHeightOptions = [
    { value: 40,     i18nKey: "row_height_compact" },
    { value: 64,     i18nKey: "row_height_default" },
    { value: 88,     i18nKey: "row_height_spacious" },
    { value: "auto", i18nKey: "row_height_fit" },
];
export const SH_DATAGRID_DEFAULT_ROW_HEIGHT = 64;
export const SH_DATAGRID_AUTO_ROW_HEIGHT_MIN_PADDING_Y = 12;
